function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert, Select, message, Upload, InputNumber } from "antd";
import Common from "../includes/Common";
import { Upload as UpIc } from "react-bootstrap-icons";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";

var AddEmployee = function AddEmployee(_ref) {
  var handler = _ref.handler;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFormLoading = _useState2[0],
      setIsFormLoading = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      formError = _useState4[0],
      setFormError = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      formSuccess = _useState6[0],
      setFormSuccess = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      deptOptions = _useState8[0],
      setDeptOptions = _useState8[1];

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      file = _useState10[0],
      setFile = _useState10[1];

  var props = {
    onRemove: function onRemove(file) {
      setFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setFile(file);
      return false;
    },
    accept: ".png,.jpg,.jpeg",
    maxCount: 1
  };

  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    setFormError('');
    setFormSuccess('');
    var formData = new FormData();
    formData.append('firstname', values.firstname);
    formData.append('lastname', values.lastname);
    formData.append('mobile', values.mobile);
    formData.append('matricule', values.matricule);
    formData.append("base_salary", values.base_salary);
    formData.append('email', values.email);
    formData.append("job", values.job);
    formData.append('user_id', Common.currentUser.id);
    formData.append("photo", file);
    axios.post(Common.baseApiUrl + 'createemployee', formData).then(function (response) {
      if (response.data.status == 200) {
        setFormSuccess('Opération réussie');
        handler();
      } else {
        setFormError(response.data.message);
      }
    })["catch"](function (error) {
      setFormError('Une erreur est survenue ' + error.toString());
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };

  useEffect(function () {
    axios.get(Common.baseApiUrl + 'getdepartments').then(function (response) {
      if (response.data.status == 200) {
        response.data.departments.forEach(function (d) {
          setDeptOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: d.id,
              label: d.label
            }]);
          });
        });
        form.setFieldsValue({
          department_id: deptOptions
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {});
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [formError.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: formError,
          showIcon: true
        })
      }), formSuccess.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "success",
          message: formSuccess,
          showIcon: true
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "matricule",
        label: "Matricule",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsxs("fieldset", {
        children: [/*#__PURE__*/_jsx("legend", {
          children: "INFORMATIONS PERSONNELLES"
        }), /*#__PURE__*/_jsx(Form.Item, {
          name: "firstname",
          label: "Pr\xE9nom",
          rules: [{
            required: true,
            message: 'Ce champs est obligatoire'
          }],
          children: /*#__PURE__*/_jsx(Input, {})
        }), /*#__PURE__*/_jsx(Form.Item, {
          name: "lastname",
          label: "Nom",
          rules: [{
            required: true,
            message: 'Ce champs est obligatoire'
          }],
          children: /*#__PURE__*/_jsx(Input, {})
        }), /*#__PURE__*/_jsx(Form.Item, {
          name: "job",
          label: "Poste",
          rules: [{
            required: true,
            message: 'Ce champs est obligatoire'
          }],
          children: /*#__PURE__*/_jsx(Input, {})
        }), /*#__PURE__*/_jsx(Form.Item, {
          name: "mobile",
          label: "T\xE9l\xE9phone",
          rules: [{
            required: true,
            message: 'Ce champs est obligatoire'
          }],
          children: /*#__PURE__*/_jsx(Input, {})
        }), /*#__PURE__*/_jsx(Form.Item, {
          name: "email",
          label: "E-mail",
          children: /*#__PURE__*/_jsx(Input, {})
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "base_salary",
        label: "Salaire de base",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {
          addonAfter: "GNF"
        })
      }), /*#__PURE__*/_jsxs("fieldset", {
        children: [/*#__PURE__*/_jsx("legend", {
          children: "PHOTO"
        }), /*#__PURE__*/_jsx(Form.Item, {
          children: /*#__PURE__*/_jsx(Upload, _objectSpread(_objectSpread({}, props), {}, {
            children: /*#__PURE__*/_jsx(Button, {
              type: "primary",
              icon: /*#__PURE__*/_jsx(UpIc, {
                size: 20
              }),
              children: /*#__PURE__*/_jsx("b", {
                children: "JOINDRE UNE PHOTO"
              })
            })
          }))
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          htmlType: "submit",
          disabled: deptOptions.length == 0,
          loading: isFormLoading,
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "CREER"
          })
        })
      })]
    })
  });
};

export default AddEmployee;